export const getLayoutBoxThumbnail = (layoutBox) => {
  const element = typeof layoutBox === 'string'
    ? document.getElementById(layoutBox)
    : layoutBox;

  if (element.tagName === 'image') return element;

  return element.querySelector('image') || element;
};

const getLayoutBoxCoordImage = (layoutBox) => {
  const thumbnail = getLayoutBoxThumbnail(layoutBox);
  const getAttribute = name => Math.floor4(thumbnail.getAttribute(name));
  /* coordinates also receive thumbnail.textContent for backward compatibility */
  const coordinates = layoutBox.dataset.boxCoordinates || thumbnail.textContent;

  let arBb = coordinates.split(/[^-|\d.]/).map(attribute => Math.floor4(attribute));
  if (arBb.length < 4) {
    arBb = [
      getAttribute('x'),
      getAttribute('y'),
      getAttribute('width'),
      getAttribute('height')
    ];
  }

  const [x, y, width, height] = arBb;
  return { x, y, width, height };
};

const getLayoutBoxCoordLogo = (logo) => {
  const image = logo.querySelector('image');
  if (image) {
    return getLayoutBoxCoordImage(logo);
  }

  return {
    x: Math.floor4(logo.dataset.boundingX),
    y: Math.floor4(logo.dataset.boundingY),
    width: Math.floor4(logo.dataset.boundingWidth),
    height: Math.floor4(logo.dataset.boundingHeight)
  };
};

const getLayoutBoxCoordVideo = (video) => {
  const coordinate = video.dataset.boxCoordinates.split(/[^-|\d.]/).map(attribute => Math.floor4(attribute));
  const [x, y, width, height] = coordinate;
  return { x, y, width, height };
};

export const getLayoutBoxCoord = (layoutBox, type) => {
  switch (type) {
    case 'image':
      return getLayoutBoxCoordImage(layoutBox);
    case 'logo':
      return layoutBox.getBBox();
    case 'icon':
      return layoutBox.getBBox();
    case 'video':
      return getLayoutBoxCoordVideo(layoutBox);
    case 'text':
      return layoutBox.getBBox();
    default:
      return {};
  }
};

export const getElementType = (element) => {
  const helper = INKIVE.Helpers.elementHelper(element);
  return (helper.hasLayoutBox() && !helper.isVideo()) ? 'image' : INKIVE.DesignFacade.getType(element);
};

export const getHoveredElement = (x, y, sourceType) => {
  const layoutList = [...document.querySelectorAll('.element')];

  const zoom = INKIVE.EditorFacade.canvas.getZoom();
  for (let i = layoutList.length - 1; i >= 0; i--) {
    const destType = getElementType(layoutList[i]);

    if (sourceType !== destType) {
      continue;
    }

    const clipPathSize = getLayoutBoxCoord(layoutList[i], destType);

    if (clipPathSize.x * zoom < x &&
      x < (clipPathSize.x + clipPathSize.width) * zoom &&
      clipPathSize.y * zoom < y &&
      y < (clipPathSize.y + clipPathSize.height) * zoom) {
      return layoutList[i];
    }
  }
};

export const getFullSize = (imgSize, layout) => {
  const imgFullSize = {
    x: 0,
    y: 0,
    width: Math.floor4(imgSize.width * layout.height / imgSize.height),
    height: Math.floor4(imgSize.height * layout.height / imgSize.height)
  };

  if (imgFullSize.width < layout.width) {
    imgFullSize.width = Math.floor4(imgSize.width * layout.width / imgSize.width);
    imgFullSize.height = Math.floor4(imgSize.height * layout.width / imgSize.width);
    imgFullSize.y = Math.floor4((imgFullSize.height - layout.height) / 2);
  } else {
    imgFullSize.x = Math.floor4((imgFullSize.width - layout.width) / 2);
  }

  return imgFullSize;
};
